import React from "react";

function Medication() {
  return (
    <div className="card h-[370px] w-[370px] m-5 border rounded-lg">
      <div className="header h-[13%] bg-blue-400 flex items-center justify-center rounded p-2">
        <h1 className="font-bold text-normal text-blue-950 mt-3">Medication</h1>
      </div>
      <div className="body h-[75%] scrollwidth overflow-y-auto bg-white border-t-2 border-t-blue-900">
        <div className="items-center m-3 p-2 border rounded-md text-sm">
          <p className="font-semibold">Drug Name: <span className="font-medium text-gray-500">Amlopres 10 Tablet</span></p>
          <p className="font-semibold">Composition: <span className="font-medium text-gray-500">Amlodipine 10mg</span></p>
          <p className="font-semibold">Dosage: <span className="font-medium text-gray-500">10mg</span></p>
          <p className="font-semibold">Frequency: <span className="font-medium text-gray-500">0-0-1</span></p>
          <p className="font-semibold">Duration: <span className="font-medium text-gray-500">30 Days</span></p>
          <p className="font-semibold">Indication: <span className="font-medium text-gray-500">Cardiac</span></p>
          <p className="font-semibold">Side Effects: <span className="font-medium text-gray-500">Not known</span></p>
          <p className="font-semibold">Compliance: <span className="font-medium text-gray-500">NA</span></p>
          <p className="font-semibold">Adverse Effects: <span className="font-medium text-gray-500">NA</span></p>
          <p className="font-semibold">Advice related to medicines: <span className="font-medium text-gray-500">NA</span></p>
          <div className="ml-auto font-medium mt-2 flex justify-start">
              <h5 className="text-gray-500 font-semibold text-sm">
                Onset date: <span>2024-12-21</span>
              </h5>
            </div>
        </div>
      </div>
      <div className="footer h-[44px] bg-blue-400 rounded"></div>
    </div>
  );
}

export default Medication;
